<template>
  <button @click="toggle">
    <span class="flex items-center">
      <slot />
      <UiIcon
        icon="chevronDown"
        class="ml-2 transition"
        :class="{ 'rotate-180': isOpen }"
      />
    </span>
  </button>
</template>

<script setup lang="ts">
import { inject } from 'vue';
import type { Ref } from 'vue';

const isOpen = inject('isOpen') as Ref<boolean>;
const toggle = inject('toggle') as () => void;
</script>
